import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { useNavigate, Routes, Route } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import AdminSidebar from './AdminSidebar';
import AdminHomeTab from './AdminHomeTab';
import UsersListTab from './UsersListTab';

import ApiLogsTab from './ApiLogsTab';
import EmailLogsTab from './EmailLogsTab';
import ApiSettingsTab from './ApiSettingsTab';
import SubscriptionsTab from './SubscriptionsTab';
import BillingTab from './BillingTab';
import NotificationsTab from './NotificationsTab';
// import BlogManagementTab from './BlogManagementTab';
import CreateBlog from './CreateBlog';
import EditBlog from './EditBlog';
import SupportTicketsTab from './SupportTicketsTab';
import ForwardPremiumsTab from './ForwardPremiumsTab';
import {
  IndianCustomsRatesTab,
  RbiReferenceRatesTab,
} from './ReferenceRatesAdminTab';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  const handleLogout = () => {
    // Add your logout logic here
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <div className="dashboard-container">
      {/* Mobile Menu Button */}
      <Button 
        variant="dark" 
        className="mobile-menu-btn d-md-none"
        onClick={toggleMobileMenu}
      >
        <FaBars />
      </Button>

      <Row className="h-100 g-0">
        <Col className={`sidebar-col p-0 ${showMobileMenu ? 'show' : ''}`} style={{ width: isCollapsed ? '60px' : '250px' }}>
          <AdminSidebar 
            isCollapsed={isCollapsed}
            toggleSidebar={toggleSidebar}
            onLogout={handleLogout}
          />
        </Col>
        <Col className={`content-col ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
          <div className="content-wrapper">
            <Routes>
              <Route path="/" element={<AdminHomeTab />} />
              <Route path="/users" element={<UsersListTab />} />

              <Route path="/api-logs" element={<ApiLogsTab />} />
              <Route path="/email-logs" element={<EmailLogsTab />} />
              <Route path="/api-settings" element={<ApiSettingsTab />} />
              <Route path="/forward-premiums" element={<ForwardPremiumsTab />} />
              <Route path="/rbi-reference-rates" element={<RbiReferenceRatesTab />} />
              <Route path="/indian-customs-rates" element={<IndianCustomsRatesTab />} />
              <Route path="/subscriptions" element={<SubscriptionsTab />} />
              <Route path="/invoice" element={<BillingTab />} />
              <Route path="/notifications" element={<NotificationsTab />} />
              {/* <Route path="/blog-management" element={<BlogManagementTab />} /> */}
              <Route path="/create-blog" element={<CreateBlog />} />
              <Route path="/edit-blog/:id" element={<EditBlog />} />
              <Route path="/support-tickets" element={<SupportTicketsTab />} />
            </Routes>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default AdminDashboard; 